import CountryService from '../services/CountryService';

export const vatDescription = () => {
  const { countryCode } = CountryService.GetInstance();

  return countryCode && countryCode.toLowerCase() === 'us' ? 'GST' : 'VAT';
};


// WEBPACK FOOTER //
// ./src/helpers/vatDescription.ts